{
  "title": "Reports",
  "tabs": {
    "summary": "Transfers summary",
    "detailed": "Detailed transactions",
    "by-branch": "By branch",
    "by-employee": "By employee",
    "by-customer": "By customer",
    "holders": "Box and account movements and balances"
  },
  "filters": {
    "branch": "Branch",
    "employee": "Employee",
    "box": "Box",
    "bankAccount": "Bank account",
    "customer": "Customer",
    "direction": "Direction"
  },
  "actions": {
    "exportExcel": "Export to Excel",
    "exportPdf": "Export PDF"
  },
  "summary": {
    "transferCount": "Transfer count",
    "totalAmount": "Total transfer amounts",
    "totalCommission": "Total commissions",
    "commissionNote": "Service income, not net profit after expenses.",
    "totalNet": "Total net",
    "cancelledTitle": "Cancelled transfers",
    "cancelledLine": "{{count}} transfers totalling {{amount}}",
    "cancelledExcludedNote": "Excluded from the totals above."
  },
  "detailed": {
    "title": "Detailed transactions",
    "columns": {
      "number": "Transfer number",
      "direction": "Direction",
      "date": "Date",
      "branch": "Branch",
      "sender": "Sender",
      "receiver": "Receiver",
      "amount": "Transfer amount",
      "commission": "Commission",
      "net": "Net",
      "bankAccount": "Bank account",
      "box": "Box",
      "employee": "Employee",
      "state": "Status"
    },
    "rowActions": {
      "trigger": "Actions for transfer {{number}}",
      "viewDetails": "View Details"
    },
    "states": {
      "DRAFT": "Draft",
      "POSTED": "Posted",
      "CANCELLED": "Cancelled"
    }
  },
  "grouped": {
    "columns": {
      "count": "Transfer count",
      "amount": "Amount",
      "commission": "Commission",
      "net": "Net",
      "cancelledCount": "Cancelled"
    },
    "totalRow": "Total"
  },
  "byBranch": {
    "title": "By branch",
    "columns": {
      "branch": "Branch"
    }
  },
  "byEmployee": {
    "title": "By employee",
    "columns": {
      "employee": "Employee"
    }
  },
  "byCustomer": {
    "title": "By customer",
    "columns": {
      "customer": "Customer",
      "asSender": "As sender",
      "asReceiver": "As receiver"
    }
  },
  "holders": {
    "title": "Box and account movements and balances",
    "kind": {
      "BOX": "Box",
      "BANK_ACCOUNT": "Bank account"
    },
    "columns": {
      "holder": "Box / account",
      "opening": "Opening balance",
      "totalIn": "Total in",
      "inByType": "In by type",
      "totalOut": "Total out",
      "outByType": "Out by type",
      "closing": "Closing balance"
    },
    "sharedAccountNote": "A bank account shared by several branches appears once in this report.",
    "notBankReadingNote": "Balances shown are the result of recorded movements, not a bank statement reading."
  }
}
